export default "__VITE_ASSET__07e888e1__"